import PropTypes from 'prop-types';
import React from 'react';
import { Container } from './styled';

const Button = ({ text, ...props }) => {
  return <Container {...props}>{text}</Container>;
};

Button.propTypes = {
  text: PropTypes.string.isRequired
};

export default Button;
